import { Stack } from "@mantine/core"
import { DataFetchWrapper } from "@tfg/ui"
import { useState } from "react"

import { findBouncedEmailsFilterType } from "@tfg/types/schemas/admin"

import { BouncedEmailsTable } from "~/pages/Admin/Exports/BouncedEmails/BouncedEmailsTable"
import { useGetBouncedEmails } from "~/pages/Admin/Exports/BouncedEmails/hooks/useGetBouncedEmails"

export function BouncedEmailsContainer() {
  const [filters, setFilters] = useState<findBouncedEmailsFilterType>({
    event: undefined,
    inviterCompanyId: undefined,
    supplierEmail: undefined,
    date: null,
  })
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 15 })
  const query = useGetBouncedEmails({
    fetchDataOptions: {
      ...pagination,
    },
    filters,
  })

  return (
    <Stack>
      <DataFetchWrapper query={query}>
        {({ data }) => (
          <BouncedEmailsTable
            bouncedEmails={data}
            setFilters={setFilters}
            filters={filters}
            setPagination={setPagination}
            pagination={pagination}
          />
        )}
      </DataFetchWrapper>
    </Stack>
  )
}
